import React, { useEffect, useState } from 'react';
import { Alert, Button, ButtonGroup, Col, Container, Modal, Row, Spinner, Table } from 'react-bootstrap';
import { connect } from 'react-redux';
import { apiUrl, businessName } from '../../utils/consts';
import { formatMoney } from '../../utils/formatMoney';
import { withRouter } from 'react-router';
import moment from 'moment';
import './styles/wallet.scss';

const select = state => {
  return {
    user: state.auth.user,
    userId: state.auth.userId,
    token: state.auth.token
  };
};

function ConnectedWallet(props) {

  const { token, userId, user } = props;

  const [loading, setLoading] = useState(true);
  const [creatingDisbursment, setCreatingDisbursment] = useState(false);
  const [payments, setPayments] = useState([]);
  const [disbursements, setDisbursements] = useState([]);
  const [purchases, setPurchases] = useState([]);
  const [totalRaised, setTotalRaised] = useState(0);
  const [disbursedTotal, setDisbursedTotal] = useState(0);
  const [amountAvailable, setAmountAvailable] = useState(0);
  const [totalComisionNibi, setTotalComisionNibi] = useState(0);
  const [totalCostosFinancieros, setTotalCostosFinancieros] = useState(0);
  const [totalImpuestos, setTotalImpuestos] = useState(0);
  const [totalDescuentos, setTotalDescuentos] = useState(0);
  const [totalAvailable, setTotalAvailable] = useState(0);
  const [cuatroPorMil, setCuatroPorMil] = useState(0);

  const [showModal, setShowModal] = useState(false);
  const [tab, setTab] = useState(0);
  const costoTransferencia = user.bankName && user.bankName.toLowerCase() === 'bancolombia' ? 0 : 7800;

  useEffect(() => {
    getData();
  }, []);

  const handleClose = () => {
    setShowModal(false);
  };

  const getData = async () => {
    setLoading(true);

    const paymentsProm = await fetch(`${apiUrl}/products/get/wallet`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        userId,
        token,
        businessName
      })
    });

    const paymentsResp = await paymentsProm.json();

    if (paymentsResp.success) {
      const { payments, disbursements, purchases } = paymentsResp;

      const reduceFunc = (accumulator, item) => {
        const sum = item.status === 'RECEIVED' ? item.totalAmount : 0;
        return accumulator + sum;
      };

      let raised = 0;
      let comisionNibi = 0;
      let costosFinancieros = 0;
      let impuestos = 0;

      payments.forEach(item => {
        raised += item.amount;
        costosFinancieros += (item.feePasarela + item.comisionPasarela);
        comisionNibi += item.fareNibi;
        impuestos += (item.retencionFuente + item.retencionICA + item.retencionIVA + item.iva);
      });

      const disbursed = disbursements.reduce(reduceFunc, 0);

      const totalDescuentos = costosFinancieros + impuestos + comisionNibi;
      const totalAvailable = raised - totalDescuentos - disbursed;
      const cuatroPorMil = totalAvailable * 4 / 1000;

      const available = totalAvailable - cuatroPorMil - costoTransferencia;

      setPurchases(purchases);
      setPayments(payments);
      setDisbursements(disbursements);
      setDisbursedTotal(disbursed);
      setAmountAvailable(available);
      setTotalRaised(raised);
      setTotalComisionNibi(comisionNibi);
      setTotalCostosFinancieros(costosFinancieros);
      setTotalImpuestos(impuestos);
      setTotalDescuentos(totalDescuentos);
      setTotalAvailable(totalAvailable);
      setCuatroPorMil(cuatroPorMil);
    }

    setLoading(false);
  };

  const createDisbursement = async () => {

    setCreatingDisbursment(true);

    const createProm = await fetch(`${apiUrl}/disbursements/create`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        userId,
        token,
        businessName,
        amount: amountAvailable,
        transactionCost: costoTransferencia,
        cuatroPorMil
      })
    });

    const createResp = await createProm.json();

    if (!createResp.success) {
      alert(createResp.message || 'Ocurrió un error. Inténtalo nuevamente.');
    } else {
      alert('Desembolso solicitado correctamente.');
      handleClose();
      getData();
      setTab(2);
    }

    setCreatingDisbursment(false);

  };

  const disbursementAvailable = !disbursements.find(item => item.status === 'REQUESTED');
  const bankFiles = user.bankAccountCertificate && user.bankAccountNumber && user.bankAccountType && user.bankName;

  if (loading) {
    return (
      <div className="wallet-component">
        <div className="center">
          <Spinner variant="primary" animation="grow" />
        </div>
      </div>
    );
  }

  return (
    <div className="wallet-component">
      <Container>
        <Row>
          <Col>
            <h3>Billetera</h3>
            <h5>Disponible: ${amountAvailable > 0 ? formatMoney(amountAvailable) : 0} COP</h5>

            <Button className="app-button" onClick={() => setShowModal(true)}>
              Solicitar desembolso
            </Button>
            <br /><br />

            <ButtonGroup>
              <Button variant={tab === 0 ? 'secondary' : 'outline-secondary'} onClick={() => setTab(0)}>
                Compras
              </Button>
              <Button variant={tab === 1 ? 'secondary' : 'outline-secondary'} onClick={() => setTab(1)}>
                Ventas
              </Button>
              <Button variant={tab === 2 ? 'secondary' : 'outline-secondary'} onClick={() => setTab(2)}>
                Desembolsos
              </Button>
            </ButtonGroup>
            {
              tab === 0 ?
              <>
                <h5>Compras</h5>
                <Table striped bordered hover size="sm">
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Producto</th>
                      <th>Fecha</th>
                      <th>Monto</th>
                    </tr>
                  </thead>
                  <tbody>
                    {
                      purchases.map((item, index) =>
                        <tr key={item._id}>
                          <td>{index + 1}</td>
                          <td>{item.product.name}</td>
                          <td>{moment(item.dateCreated).format('YYYY-MM-DD')}</td>
                          <td>${formatMoney(item.amount)}</td>
                        </tr>
                      )
                    }
                  </tbody>
                </Table>
              </> :
              tab === 1 ?
              <>
                <h5>Ventas</h5>
                <Table striped bordered hover size="sm">
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Producto</th>
                      <th>Fecha</th>
                      <th>Monto</th>
                      <th>Fecha de desembolso</th>
                    </tr>
                  </thead>
                  <tbody>
                    {
                      payments.map((item, index) => {

                        const {
                          product,
                          amount,
                          dateCreated,
                          disbursementId,
                          disbursementDate
                        } = item;

                        return (
                          <tr key={item._id}>
                            <td>{index + 1}</td>
                            <td>{product.name}</td>
                            <td>{moment(dateCreated).format('YYYY-MM-DD')}</td>
                            <td>${formatMoney(amount)}</td>
                            <td>{disbursementId && disbursementDate ? moment(disbursementDate).format('YYYY-MM-DD') : '-'}</td>
                          </tr>
                        );

                      })
                    }
                  </tbody>
                </Table>
              </> :
              <>
                <h5>Desembolsos</h5>
                <Table striped bordered hover size="sm">
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Monto</th>
                      <th>Estado</th>
                      <th>Fecha de solicitud</th>
                      <th>Fecha de desembolso</th>
                    </tr>
                  </thead>
                  <tbody>
                    {
                      disbursements.map((item, index) =>
                        <tr key={item._id}>
                          <td>{index + 1}</td>
                          <td>${formatMoney(item.amount)}</td>
                          <td>{item.status === 'REQUESTED' ? 'Solicitado' : 'Recibido'}</td>
                          <td>{moment(item.dateRequested).format('YYYY-MM-DD')}</td>
                          <td>
                            {
                              item.datePayed ?
                              moment(item.datePayed).format('YYYY-MM-DD') :
                              '-'
                            }
                          </td>
                        </tr>
                      )
                    }
                  </tbody>
                </Table>
              </>
            }
          </Col>
        </Row>
      </Container>

      <Modal show={showModal} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>
            Solicitar desembolso
          </Modal.Title>
        </Modal.Header>

        <Modal.Body className="disbursement-modal-content">
          <h6>Resumen de cuentas</h6>

          <Row style={{ fontSize: '0.9em' }}>
            <Col md={12}>
              <Row>
                <Col>
                  <strong style={{ fontSize: '0.9em', color: 'gray' }}>Total recaudado</strong>
                </Col>
                <Col>
                  <div style={{ textAlign: 'right' }}>
                    <strong>{formatMoney(totalRaised)}</strong>
                  </div>
                </Col>
              </Row>

              <Row>
                <Col>
                  <strong style={{ fontSize: '0.9em', color: 'gray' }}>Costos financieros</strong>
                </Col>
                <Col>
                  <div style={{ textAlign: 'right' }}>
                    {formatMoney(totalCostosFinancieros)}
                  </div>
                </Col>
              </Row>

              <Row>
                <Col>
                  <strong style={{ fontSize: '0.9em', color: 'gray' }}>Impuestos</strong>
                </Col>
                <Col>
                  <div style={{ textAlign: 'right' }}>
                    {formatMoney(totalImpuestos)}
                  </div>
                </Col>
              </Row>

              <Row>
                <Col>
                  <strong style={{ fontSize: '0.9em', color: 'gray' }}>Tarifas nibi</strong>
                </Col>
                <Col>
                  <div style={{ textAlign: 'right' }}>
                    {formatMoney(totalComisionNibi)}
                  </div>
                </Col>
              </Row>

              <Row>
                <Col>
                  <strong style={{ fontSize: '0.9em', color: 'gray' }}>Total descuentos</strong>
                </Col>
                <Col>
                  <div style={{ textAlign: 'right' }}>
                    <strong>{formatMoney(totalDescuentos)}</strong>
                  </div>
                </Col>
              </Row>

              <Row>
                <Col>
                  <strong style={{ fontSize: '0.9em', color: 'gray' }}>Total desembolsos</strong>
                </Col>
                <Col>
                  <div style={{ textAlign: 'right' }}>
                    <strong>{formatMoney(disbursedTotal)}</strong>
                  </div>
                </Col>
              </Row>

              <Row>
                <Col>
                  <strong style={{ fontSize: '0.9em', color: 'gray' }}>Disponible para desembolso</strong>
                </Col>
                <Col>
                  <div style={{ textAlign: 'right' }}>
                    <strong>{formatMoney(totalAvailable)}</strong>
                  </div>
                </Col>
              </Row>

              <Row>
                <Col sm={8}>
                  <strong style={{ fontSize: '0.9em', color: 'gray' }}>Cuatro por mil</strong>
                </Col>
                <Col sm={4}>
                  <div style={{ textAlign: 'right' }}>{formatMoney(cuatroPorMil)}</div>
                </Col>
              </Row>

              <Row>
                <Col sm={8}>
                  <strong style={{ fontSize: '0.9em', color: 'gray' }}>Costo tranferencia bancaria</strong>
                </Col>
                <Col sm={4}>
                  <div style={{ textAlign: 'right' }}>{formatMoney(costoTransferencia)}</div>
                </Col>
              </Row>

              <Row>
                <Col>
                  <strong style={{ fontSize: '0.9em', color: 'gray' }}>Total disponible</strong>
                </Col>
                <Col>
                  <h5 style={{ textAlign: 'right' }}>
                    <strong>
                      {amountAvailable > 0 ? formatMoney(amountAvailable) : 0}
                    </strong>
                  </h5>
                </Col>
              </Row>

            </Col>
          </Row>

          <Button
            className="app-button"
            disabled={!disbursementAvailable || creatingDisbursment || amountAvailable <= 0 || !bankFiles}
            onClick={createDisbursement}
          >
            {
              creatingDisbursment ?
              <Spinner size="sm" variant="warning" animation="border" /> :
              'Solicitar desembolso'
            }
          </Button>

          {
            !disbursementAvailable &&
            <Alert variant="warning">
              No puedes solicitar un desembolso debido a que tienes una solicitud de desembolso que aún no hemos depositado.
            </Alert>
          }
          {
            !bankFiles &&
            <Alert variant="warning">
              Para solicitar un desembolso primero debes subir los documentos correspondientes a tu información bancaria.
              Esto lo puedes realizar en la sección de <span className="wallet-link" onClick={() => props.history.push('/dashboard/documentos')}><strong>Documentos.</strong></span>
            </Alert>
          }
        </Modal.Body>
      </Modal>

    </div>
  );

}

const WalletComponent = connect(select)(ConnectedWallet);

export default withRouter(WalletComponent);
